import React, { Fragment, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { actionTypes as appActionTypes, selectors as appSelectors } from '../features/app'
import { selectors as errorSelectors } from '../features/error'
import { selectors as vehicleSelectors } from '../features/vehicle'
import { actionTypes as valuationActionTypes } from '../features/valuation'
import ConditionForm from '../forms/Condition'
import DetailForm from '../forms/Detail'
import { postValuation } from '../api'
import { AnalyticElement, baseName, IAnalyticEvent, IValuationRequest, Routes } from '../types.d'
import { actionTypes as errorActionTypes } from '../features/error'
import { IError, IErrorButton } from '../features/error/types'
import { getArrayFromObject, scrollToBeginning } from '../helpers'
import SendEvent from '../analytics'

export const Condition: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const subStep = useSelector(appSelectors.getAppSubStep);
  const redbookCode = useSelector(vehicleSelectors.getVehicleRedbookCode);
  const kms = useSelector(vehicleSelectors.getVehicleKms);
  const [isInit, setIsInit] = useState(false);
  const isLoading = useSelector(appSelectors.getAppIsLoading);
  const isError = useSelector(errorSelectors.getErrorTitle);
  const redbookcode = useSelector(vehicleSelectors.getVehicleRedbookCode); 
  const [currentFormHeading, setCurrentFormHeading] = useState('');
  const [conditionStep, setConditionStep] = useState(0);

  const handleHeadingChange = (h: string, n: number) => {
    setConditionStep(n);
    setCurrentFormHeading(h);
    scrollToBeginning();
    SendEvent({
      event: 'sendVirtualPageView',
      pageType: 'instantoffer',
      viewSection: `condition section ${n+1}`,
      viewName: 'condition',
    });
  }
  const handleDetailSubmit = (data: any) => {
    dispatch({ type: appActionTypes.SET_APP, payload: { isLoading: true } });
    SendEvent({
      event: 'formSubmit',
      formName: 'detail'
    });
    history.push(Routes.Personal);
  };
  const handleConditionSubmit = (data: any) => {
    SendEvent({
      event: 'formSubmit',
      formName: 'condition'
    });
    dispatch({ type: appActionTypes.SET_APP, payload: { isLoading: true } });
    getValuation(data);
  }
  const getValuation = async (data: any) => {
    const conditionsObject = data;
    const conditionsArray = getArrayFromObject(conditionsObject, 'number', 'value');
    const valuationRequest:IValuationRequest = {
      conditions: conditionsArray,
      redbookCode: redbookCode,
      kms: parseInt(kms)
    };
    const valuation = await postValuation(valuationRequest);
    if (valuation && !valuation.errormessage){
      const expiry = new Date();
      const now = new Date(expiry);
      expiry.setDate(expiry.getDate() + 13);
      dispatch({ type: valuationActionTypes.SET_VALUATION, payload: valuation.result });
      dispatch({ type: appActionTypes.SET_APP, payload: { 
        subStep: 1, 
        isLoading: false,
        expiry: expiry.toISOString(), 
        offerDate: now.toISOString()
      } });
      scrollToBeginning();
      SendEvent({
        event: 'sendVirtualPageView',
        pageType: 'instantoffer',
        viewSection: 'details',
        viewName: 'condition',
      });
    }
    else {
      const btns: Array<IErrorButton> = [
        {
          title: 'Back to registration', 
          classes: 'button-outline', 
          callback: () => { location.pathname = baseName + Routes.Specs }, 
          clearErrorOnClick: true
        }
      ]
      const err: IError = { 
        icon: require('../assets/images/barricade.svg'),
        title: 'Sorry, we seem to be experiencing some technical difficulties, please try again later.',
        buttons: btns
      };
      dispatch({ type: errorActionTypes.SET_ERROR, payload: err });
    }
    dispatch({ type: appActionTypes.SET_APP, payload: { isLoading: false } });
  };
  const handleConditionsLoaded = () => {
    dispatch({ type: appActionTypes.SET_APP, payload: { isLoading: false } });
  };
  const handleConditionAnalyticEvent = (evt: IAnalyticEvent) => {
    switch (evt.element){
      case AnalyticElement.Button:
        SendEvent({
          event: 'sendEvent',
          eventCategory: 'User Interactions',
          eventAction: `Instant Offer - condition section ${conditionStep+1}`,
          eventLabel: `Continue - button click`,
          eventValue: 0,
          nonInteraction: false
        });
        break;
    }
  }
  const handleDetailAnalyticEvent = (evt: IAnalyticEvent) => {
    switch (evt.element){
      case AnalyticElement.Button:
        SendEvent({
          event: 'sendEvent',
          eventCategory: 'User Interactions',
          eventAction: `Instant Offer - detail`,
          eventLabel: `Continue - button click`,
          eventValue: 0,
          nonInteraction: false
        });
        break;
    }
  }
  useEffect(() => {
    if (!isInit){
      setIsInit(true);
      if (!redbookcode) history.replace(Routes.Specs);
      dispatch({ type: appActionTypes.SET_APP, payload: { step: 1, subStep: 0 } });
      scrollToBeginning();
    }
  });

  return (
    <Fragment>
      <section className={`i-step-all ${isLoading || isError ? 'i-loading' : ''}`}>
        <div className="i-con">
          <div className="i-row i-step-all-row">
            <div className="i-col">
              <h2>
                {subStep === 0 ? 
                  `What is the ${currentFormHeading.toLowerCase()} condition of your car?`
                  : 
                  'Please provide a few final details about your car'
                }
                </h2>
            </div>
            <div className="i-col">
              {subStep === 0 ? 
                <ConditionForm 
                  handleAnalyticEvent={handleConditionAnalyticEvent}
                  handleHeadingChange={handleHeadingChange}
                  handleConditionsLoaded={handleConditionsLoaded} 
                  handleConditionSubmit={handleConditionSubmit} 
                />
                : 
                <DetailForm handleAnalyticEvent={handleDetailAnalyticEvent} handleDetailSubmit={handleDetailSubmit} /> 
              }
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  )
}
